import {
  FETCH_DISCOUNT,
  RESET_DISCOUNT,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const subofferViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_SUBOFFER":
      return { data: action.payload };
    case "RESET_SUBOFFER":
      return initialState;
    default:
      return state;
  }
};

export default subofferViewReducer;
